import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import "./ContactSection.css";
import ContactImg from "./images/contact2.png";

const ContactUs = ({ isDarkMode }) => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [popup1, setPopup] = useState({ show: false, message: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, email, message } = formData;
    if (!name || !email || !message) {
      showPopup("All fields are required.", "error");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("http://localhost:5000/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        showPopup("Message sent successfully!", "success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        showPopup(data.error || "Something went wrong!", "error");
      }
    } catch (error) {
      showPopup(`Error: ${error.message}`, "error");
    }

    setLoading(false);
  };

  const showPopup = (message, type) => {
    setPopup({ show: true, message, type });

    setTimeout(() => {
      setPopup((prevPopup) => ({ ...prevPopup, show: "hiding" }));
      setTimeout(() => {
        setPopup({ show: false, message: "", type: "" });
      }, 500);
    }, 3000);
  };

  return (
    <section className={`contact-us ${isDarkMode ? "dark" : "light"}`}>
      <div className="contact-content">
        <div className="contact-form-container">
          <h2>Get in Touch</h2>
          <p>Have a question or need a service? Reach out, and we’ll respond promptly.</p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />

            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />

            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" rows="4" value={formData.message} onChange={handleChange} required></textarea>

            <button type="submit" className="contact-button" disabled={loading}>
              {loading ? (
                <>
                  <div className="spinner"></div> Sending...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>

        <div className="contact-image">
          <div className="placeholder-image">
            <img src={ContactImg} alt="Contact AstraSight Technologies - Nairobi, Kenya" />
          </div>
          <div className="contact-phone">
            <FaPhoneAlt className="phone-icon" />
            <span className="phone-number">+254 7918 65638</span>
          </div>
        </div>
      </div>

      {/* Popup Message */}
      <div className={`popup1 ${popup1.type} ${popup1.show === "hiding" ? "hide" : popup1.show ? "show" : ""}`}>
        {popup1.message}
      </div>
    </section>
  );
};

export default ContactUs;
